import React from "react";
import "../App.css";
import i18next from "../i18n";
import { Helmet } from "react-helmet-async";
import Button from "../components/Button";
import FeatureCards from "../components/FeatureCards";
import standardizeArt from "../images/illustrations/ccm/feature-standardize.svg";
import controlArt from "../images/illustrations/ccm/feature-control.svg";
import insightArt from "../images/illustrations/ccm/feature-insight.svg";
import SubLogo from "../components/SubLogo";
import productIllustration from "../images/illustrations/docengine/product-ccm.svg";

import FlowChart from "./components/FlowChart";
import { useNavigate } from "react-router-dom";

function CCM() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.ccm.title")}</title>
        <meta name="description" content={i18next.t("pages.ccm.description")} />
        <link rel="canonical" href="https://xperconsulting.no/ccm" />
      </Helmet>
      <div className="bg-white">
        <div className="container max-w-xl flex flex-col gap-8 pt-36 items-center text-main-dark md:flex-row">
          <div className="w-full md:w-3/5 text-left  ">
            <h1 className="sr-only">
              {i18next.t("pages.ccm.title")}
            </h1>
            <SubLogo product="CCM" />
            <p className="text-xl text-secondary">
              {i18next.t("pages.ccm.description")}
            </p>
          </div>
          <div className="flex w-full justify-center md:w-2/5">
            <img src={productIllustration} alt="" aria-hidden="true" width="400" height="200" className="h-auto w-full max-w-[25rem]" />
          </div>
        </div>
        <div className="container max-w-sm mx-auto flex flex-col  text-xl text-main-dark text-left py-24">
          <p className="">
            <span className="font-bold">
              {i18next.t("pages.ccm.intro.title")}
            </span>{" "}
            {i18next.t("pages.ccm.intro.description")}
          </p>
          <p>{i18next.t("pages.ccm.benefits.description")}<span className="font-bold">{i18next.t("pages.ccm.benefits.description-bold")}</span>{i18next.t("pages.ccm.benefits.description-2")}</p>
        </div>
      </div>
      <FlowChart />
      <FeatureCards
        title="pages.ccm.featureCards.title"
        cta={{
          title: "pages.ccm.featureCards.cta.title",
          description: "pages.ccm.featureCards.cta.description",
          label: "pages.ccm.featureCards.cta.button",
          onClick: () => navigate("/skjema/kontakt-oss"),
        }}
        items={[
          {
            // To restore the original icon, uncomment it and comment out illustration.
            // icon: "standardize",
            illustration: standardizeArt,
            key: "pages.ccm.featureCards.standardize",
            tone: "warm",
          },
          {
            // To restore the original icon, uncomment it and comment out illustration.
            // icon: "control",
            illustration: controlArt,
            key: "pages.ccm.featureCards.control",
            tone: "warm",
          },
          {
            // To restore the original icon, uncomment it and comment out illustration.
            // icon: "insight",
            illustration: insightArt,
            key: "pages.ccm.featureCards.insight",
            tone: "warm",
          },
        ]}
      />
      <div className="bg-secondary">
        <div className="container max-w-xl flex-col gap-8 text-xl text-left py-24 md:flex-row md:gap-0">
          <Button
            variant="solid"
            color="main"
            size="large"
            className="max-w-full whitespace-normal md:mx-6 md:shrink-0"
            onClick={() => {
              navigate("/skjema/kontakt-oss");
            }}
          >
            {i18next.t("pages.ccm.expertise.cta")}
          </Button>

          <div className=" max-w-xs">
            <p>
              <span className="font-bold">
                {i18next.t("pages.ccm.expertise.title")}
              </span>{" "}
              {i18next.t("pages.ccm.expertise.description")}
            </p>
            <p className="max-w-xs">
              {i18next.t("pages.ccm.expertise.services")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CCM;
